module.exports = __webpack_public_path__ + "static/media/banner-dien-gio.7d270231.png";